// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3VTRL","additionalInfo":"AgreementModal_additionalInfo__1tatY"};